import React from 'react';
import axios from 'axios';
import validator from 'validator';

import VoucherItem from './VoucherItem.jsx';
import FabeInputText from './FabeInputText.jsx';
import LoadingScreen from './LoadingScreen.jsx';
import VoucherSuccess from './VoucherSuccess.jsx';

import Api from '../util/Api';
import Log from '../util/Log';
import GtmHelper from '../util/GtmHelper';
import VoucherFormValidator from '../util/validators/VoucherFormValidator';

class VoucherForm extends React.Component {
    constructor () {
        super()

        this.validator = VoucherFormValidator;

        this.state = this.getEmptyState();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.formBlockRef = React.createRef();

        this.stripe = window.Stripe(VoucherConfig.stripeApiKey);

        // this.stripeHandler = window.StripeCheckout.configure({
        //     key: VoucherConfig.stripeApiKey,
        //     image: 'https://5thavenue.ie/wp-content/uploads/2019/05/stripeimg.png',
        //     locale: 'auto',
        //     token: this.onGetStripeToken.bind(this)
        // });
    }

    handleInputChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    getEmptyState() {
        return {
            validation: this.validator.valid(),
            submitted: false,
            loading: false,
            success: false,
            to: '',
            greeting: '',
            email: '',
            phone: '',
            downloadUrl: ''
        }
    }

    getTotal() {
        if (this.props.item.fee && this.props.item.price) {
            return this.props.item.fee + this.props.item.price;
        } else {
            return this.props.item.fee;
        }
    }

    submitOrder(e) {
        try {
            const validation = this.validator.validate(this.state);
            this.setState({ validation });
            this.setState({ submitted: true });

            if (validation.isValid) {
                GtmHelper.checkoutGiftVoucher(this.props.item);
                this.createStripeSession(this.getPreparedVoucherFormData());
            }

            e.preventDefault();
        } catch (error) {
            console.error(error);
        }
    }

    // onGetStripeToken (token) {
    //     GtmHelper.payGiftVoucher(this.props.item, token.card.brand);
        
    //     // Got Stripe token. This means user's card is valid!
    //     // We need to continue the payment process by sending this token to our own server.
    //     // More info: https://stripe.com/docs/charges
    //     const data = {
    //         'voucher_title': this.props.item.title,
    //         'receipt_email': token.email,
    //         'token_id': token.id,
    //         'voucher': {
    //           greeting: this.state.greeting,
    //           to: this.state.to,
    //         },
    //         'deliver' : {
    //           email: this.state.email,
    //           phone: this.state.phone
    //         },
    //     };

    //     if (this.props.item.id === -1) {
    //         data.price = this.props.item.price;
    //         data.voucher_title = '€' + this.props.item.price + ' Gift Voucher';
    //     } else {
            
    //     }

    //     data.id = this.props.item.id;

    //     const message = 'Stripe token received (user\'s card is valid). Sending token to server.';
    //     Log.info(message, 'purchase-voucher', [{ data: data }])

    //     this.setState({ loading: true });
    //     Api.postVoucher(data, (success, response) => {
    //         if (success) {
    //             const message = 'Payment process completed. Gift voucher was successfully purchased.';
    //             Log.info(message, 'purchase-voucher', [{ request: data, response: response }])

    //             this.setState({
    //                 loading: false,
    //                 success: true,
    //                 submitted: false,
    //                 stripeToken: token,
    //                 downloadUrl: response.download_url
    //             });

    //             GtmHelper.confirmGiftVoucher(this.props.item, token.id);
    //             window.scrollTo(0, this.formBlockRef.current.offsetTop - 150);
    //         }
    //     });
    // }

    getPreparedVoucherFormData() {
        const data = {
            'id': this.props.item.id,
            'voucher_title': this.props.item.title,
            // 'receipt_email': token.email,
            // 'token_id': token.id,
            'voucher_greeting': this.state.greeting,
            'voucher_to': this.state.to,
            'deliver_email': this.state.email,
            'deliver_phone': this.state.phone,
        };

        if (this.props.item.id === -1) {
            data.price = this.props.item.price;
            data.voucher_title = '€' + this.props.item.price + ' Gift Voucher';
        }

        return data;
    }

    createStripeSession(voucherFormData) {
        voucherFormData.success_url = window.location.href + '?session_id={CHECKOUT_SESSION_ID}';
        voucherFormData.cancel_url = window.location.href + '?cancel_order=tue';

        this.setState({ loading: true });
        Api.createStripeSession(voucherFormData, (success, response) => {
            if (success) {
                this.redirectToCheckout(response.id);
            } else {

            }
        });
    }

    redirectToCheckout(sessionId) {
        this.stripe.redirectToCheckout({
            sessionId: sessionId,
        }).then((result) => {
            console.error(result.error.message);
        });
    }

    openStripe() {
        // this.stripeHandler.open({
        //     name: '5th Avenue',
        //     description: this.props.item.title,
        //     amount: this.props.item.price_in_cents + this.props.item.fee_in_cents,
        //     currency: 'eur'
        // });
    }

    renderHeader() {
        return (
            <div className='w-full lg:w-2/3 mx-auto voucher-form__header text-center'>
                <h1 className='voucher-form__title'>{trans.checkout}</h1>
                <div className='voucher-form__text'>
                    {trans.checkout_personalize.split('{{voucher_title}}')[0]}
                    <b>{this.props.item.title}</b>
                    {trans.checkout_personalize.split('{{voucher_title}}')[1]}<br/>
                    {trans.checkout_text}
                </div>
            </div>
        )
    }

    renderForm() {
        let validation = this.state.submitted
            ? this.validator.validate(this.state)
            : this.state.validation;

        return (
            <div className='container voucher-form'>
                <button className='btn btn-back' onClick={this.props.onBackClick}>
                    <span className='btn-icon'>
                        <i className='fas fa-angle-left'></i>
                    </span>
                    <span className='btn-text'>{trans.back}</span>
                </button>
                <div className='row'>
                    { this.renderHeader() }
                    <form className='w-full lg:w-2/3 mx-auto' onSubmit={this.handleSubmit}>
                        <div className='voucher-form__block'>
                            <div className='flex flex-wrap'>
                                <div className={'w-full md:w-1/3 voucher-form__input-wrapper ' + (validation.to.isInvalid && 'has-error')}>
                                    <FabeInputText
                                        name='to'
                                        label={trans.beneficiary}
                                        value={this.state.to}
                                        changeHandler={this.handleInputChange}
                                    />
                                </div>
                                <div className={'w-full md:w-2/3 voucher-form__input-wrapper ' + (validation.greeting.isInvalid && 'has-error')}>
                                    <FabeInputText
                                        name='greeting'
                                        label={trans.greeting_max_characters}
                                        value={this.state.greeting}
                                        changeHandler={this.handleInputChange}
                                        errorMessage={validation.greeting.message}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='voucher-form__block'>
                            <div className='flex flex-wrap'>
                                <div className={'w-full md:w-1/3 voucher-form__input-wrapper ' + (validation.email.isInvalid && 'has-error')}>
                                    <FabeInputText
                                        name='email'
                                        label={trans.beneficiary_email}
                                        value={this.state.email}
                                        changeHandler={this.handleInputChange}
                                        type='email'
                                    />
                                </div>
                                <div className={'w-full md:w-2/5 voucher-form__input-wrapper ' + (validation.phone.isInvalid && 'has-error')}>
                                    <FabeInputText
                                        name='phone'
                                        label={trans.beneficiary_phone}
                                        value={this.state.phone}
                                        changeHandler={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='voucher-form__block'>
                            <h4 className='voucher-form__text'>{trans.gift_voucher_admin_fee_text} {trans.currency_prepend}{this.props.item.fee}{trans.currency_append}</h4>
                            <h4 className='voucher-form__text bold'>{trans.total}: {trans.currency_prepend}{this.getTotal()}{trans.currency_append}</h4>
                            <div className='flex flex-wrap voucher-form__submit items-center'>
                                <div className='w-full md:w-1/5 voucher-form__input-wrapper'>
                                    <button className='btn btn-red w-full' disabled={this.state.loading} onClick={(e) => this.submitOrder(e)}>
                                        <span className='uppercase'>
                                            {trans.pay + ' ' + trans.currency_prepend + this.getTotal() + trans.currency_append}
                                        </span>
                                        { this.state.loading ? <span className='voucher-form__loading'><i className='fas fa-spinner fa-spin'></i></span> : '' }
                                    </button>
                                </div>
                                <div className='w-full md:w-2/3 flex items-center'>
                                    <div className="voucher-form__cards"></div>
                                    <div className='voucher-form__subtext'>{trans.powered_by_stripe}</div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                { this.state.loading ? this.renderLoadingScreen() : '' }
            </div>
        );
    }

    renderLoadingScreen() {
        return (
            <LoadingScreen
                title={trans.processing_order}
                content={<span>{trans.this_may_take_a_while}<br/>{trans.do_not_close_window}</span>}
            />
        )
    }

    renderSuccess() {
        return (
            <VoucherSuccess
                title={this.props.item.title}
                email={this.state.email}
                downloadLink={this.state.downloadUrl}
                onBackClick={this.props.onBackClick}
            />
        )
    }

    render() {
        return (
            <div ref={this.formBlockRef}>
                { this.state.success ? this.renderSuccess() : this.renderForm() }
            </div>
        );
    }
}

export default VoucherForm;


// WEBPACK FOOTER //
// ./scripts/components/VoucherForm.jsx